import * as React from "react";
// UI frameworks
import { Icon } from "antd";
// Shared components
import Button from "components/Button";
// Utilities and hooks
import { push } from "helpers/history";
// Styles
import styles from "./index.module.scss";

const ThirdStep: React.FC = () => {
	return (
		<div className={styles["main"]}>
			<h3 className={styles["main__success-message"]}>
				فروش طلا با موفقیت انجام شد و مبلغ مورد نظر به کیف پول ریالی شما اضافه گردید
			</h3>
			<div>
				<Icon type="check-circle" className={styles["main__success-icon"]} />
			</div>
			<Button onClick={() => push("/dashboard")} className={styles["main__btn"]} primary>
				بازگشت به صفحه اصلی
			</Button>
		</div>
	);
};

export default ThirdStep;
